import { render, staticRenderFns } from "./OnePageAdvantage.vue?vue&type=template&id=ca8f7bd8&"
import script from "./OnePageAdvantage.vue?vue&type=script&lang=js&"
export * from "./OnePageAdvantage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports